(function () {
  'use strict';

  var state = {
    collections: {},
    allProducts: [],
    selectedItems: [],
    maxItems: 4,
    filters: {
      occasion: '',
      collection: '',
      vendor: ''
    },
    searchQuery: '',
    isLoading: true,
    currentStep: 1,
    selectedBoxColor: '',
    config: {}
  };

  function init() {
    var container = document.querySelector('[data-gift-box-builder]');
    if (!container) return;

    var configEl = container.querySelector('[data-gbb-config]');
    if (configEl) {
      try {
        state.config = JSON.parse(configEl.textContent);
      } catch (e) {
        console.error('Gift Box Builder: Failed to parse config', e);
        return;
      }
    }

    state.maxItems = state.config.maxItems || 4;
    state.collections = {};
    state.allProducts = [];
    state.filters = { occasion: '', collection: '', vendor: '' };
    state.selectedItems = [];
    state.currentStep = 1;
    state.selectedBoxColor = '';

    var bp = state.config.boxProduct;
    if (!bp || !bp.variants || bp.variants.length === 0) {
      console.warn('Gift Box Builder: No gift box product configured. Please assign a product with Black/White variants in the theme editor.');
    } else {
      console.log('Gift Box Builder: Loaded box product', bp.title, 'with', bp.variants.length, 'variants:');
      bp.variants.forEach(function (v) {
        console.log('  Variant:', v.id, '|', v.title, '| options:', JSON.stringify(v.options), '| price:', v.price);
      });
    }

    loadAllProducts(container);
    attachEventListeners(container);
    goToStep(1, container);
  }

  function getProductImage(product) {
    var url = '';
    if (product.featured_image) {
      if (typeof product.featured_image === 'string') url = product.featured_image;
      else if (product.featured_image.src) url = product.featured_image.src;
    } else if (product.image && typeof product.image === 'object' && product.image.src) {
      url = product.image.src;
    } else if (product.images && product.images.length > 0) {
      var img = product.images[0];
      if (typeof img === 'object' && img.src) url = img.src;
      else if (typeof img === 'string') url = img;
    }
    if (url) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      url = url + separator + 'width=600&height=600&crop=center';
    }
    return url;
  }

  function formatPriceFromDollars(dollars, symbol) {
    var price = parseFloat(dollars) || 0;
    return symbol + price.toFixed(2);
  }

  function getVariant(product) {
    if (!product.variants || !product.variants.length) return null;
    var available = product.variants.find(function (v) { return v.available; });
    return available || product.variants[0];
  }

  async function loadAllProducts(container) {
    var loadingEl = container.querySelector('.gbb-step-1__loading');
    if (loadingEl) loadingEl.style.display = 'block';

    var collections = state.config.collections || [];
    var uniqueProducts = {};

    var requests = collections.map(function (col) {
      return fetch('/collections/' + col.handle + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var collectionData = data.collection;
          var collectionTitle = collectionData ? collectionData.title : col.title;
          return fetch('/collections/' + col.handle + '/products.json?limit=250')
            .then(function (r2) { return r2.json(); })
            .then(function (productData) {
              var products = (productData.products || []).map(function (p) {
                var variant = getVariant(p);
                if (!variant) return null;
                return {
                  id: p.id,
                  title: p.title,
                  handle: p.handle,
                  image: getProductImage(p),
                  price: variant.price,
                  compareAtPrice: variant.compare_at_price || null,
                  vendor: p.vendor || '',
                  description: p.body_html || '',
                  tags: normalizeTags(p.tags),
                  variantId: variant.id,
                  available: variant.available,
                  collectionHandle: col.handle,
                  collectionTitle: collectionTitle,
                  collectionHandles: [col.handle],
                  collectionTitles: [collectionTitle]
                };
              }).filter(function (p) { return p !== null; });

              state.collections[col.handle] = {
                title: collectionTitle,
                products: products
              };

              return products;
            });
        })
        .catch(function (err) {
          console.warn('Gift Box Builder: Failed to load collection ' + col.handle, err);
          state.collections[col.handle] = { title: col.title, products: [] };
          return [];
        });
    });

    var results = await Promise.all(requests);

    results.forEach(function (products) {
      if (!products) return;
      products.forEach(function (p) {
        if (!uniqueProducts[p.id]) {
          uniqueProducts[p.id] = p;
          state.allProducts.push(p);
        } else {
          if (uniqueProducts[p.id].collectionHandles.indexOf(p.collectionHandle) === -1) {
            uniqueProducts[p.id].collectionHandles.push(p.collectionHandle);
          }
          if (uniqueProducts[p.id].collectionTitles.indexOf(p.collectionTitle) === -1) {
            uniqueProducts[p.id].collectionTitles.push(p.collectionTitle);
          }
        }
      });
    });

    state.isLoading = false;
    if (loadingEl) loadingEl.style.display = 'none';
    updateFilters(container);
    renderProducts(container);
    renderSelectedSummary(container);
  }

  function updateFilters(container) {
    var filtersContainer = container.querySelector('[data-gbb-filters]');
    if (!filtersContainer) return;

    var collections = state.config.collections || [];
    var occasionOptions = collections.filter(function (col) {
      return normalizeFilterValue(col.handle) !== 'nz-made' && normalizeFilterValue(col.title) !== 'nz-made';
    }).map(function (col) {
      return { label: col.title, value: col.handle };
    });
    var collectionOptions = collections.map(function (col) {
      return { label: col.title, value: col.handle };
    });
    var vendors = uniqueValues(state.allProducts.map(function (product) { return product.vendor; }));

    var html = renderFilterSelect('occasion', 'Filter by Occasion', occasionOptions) +
      renderFilterSelect('collection', 'Filter by Collection', collectionOptions) +
      renderFilterSelect('vendor', 'Filter by Brand', vendors.map(function (vendor) { return { label: vendor, value: vendor }; })) +
      '<button type="button" class="gbb-filter-clear" data-gbb-clear-filters>Clear filters</button>';

    filtersContainer.innerHTML = html;

    filtersContainer.querySelectorAll('.gbb-filter__select').forEach(function (select) {
      select.addEventListener('change', function () {
        state.filters[select.dataset.filter] = select.value;
        renderProducts(container);
      });
    });

    var clearButton = filtersContainer.querySelector('[data-gbb-clear-filters]');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        state.filters = { occasion: '', collection: '', vendor: '' };
        filtersContainer.querySelectorAll('.gbb-filter__select').forEach(function (select) {
          select.value = '';
        });
        renderProducts(container);
      });
    }
  }

  function renderFilterSelect(name, label, options) {
    var html = '<label class="gbb-filter"><span class="visually-hidden">' + label + '</span>' +
      '<select class="gbb-filter__select" data-filter="' + name + '">' +
      '<option value="">' + label + '</option>';

    options.forEach(function (option) {
      html += '<option value="' + escapeHtml(option.value) + '">' + escapeHtml(option.label) + '</option>';
    });

    return html + '</select></label>';
  }

  function getFilteredProducts() {
    var products = state.allProducts.slice();
    var hasActiveFilters = Boolean(state.filters.occasion || state.filters.collection || state.filters.vendor || state.searchQuery);

    if (state.filters.occasion) {
      products = products.filter(function (p) {
        return productMatchesCollectionOrTag(p, state.filters.occasion);
      });
    }

    if (state.filters.collection) {
      products = products.filter(function (p) {
        return productMatchesCollectionOrTag(p, state.filters.collection);
      });
    }

    if (state.filters.vendor) {
      products = products.filter(function (p) {
        return p.vendor === state.filters.vendor;
      });
    }

    if (state.searchQuery) {
      var q = state.searchQuery.toLowerCase();
      products = products.filter(function (p) {
        return p.title.toLowerCase().indexOf(q) !== -1;
      });
    }

    if (!hasActiveFilters) {
      products.sort(function (a, b) {
        return Number(isOilPourerProduct(b)) - Number(isOilPourerProduct(a));
      });
    }

    return products;
  }

  function isOilPourerProduct(product) {
    var searchableValues = [product.title, product.collectionHandle, product.collectionTitle]
      .concat(product.collectionHandles || [])
      .concat(product.collectionTitles || [])
      .concat(product.tags || []);

    return searchableValues.some(function (value) {
      return normalizeFilterValue(value).indexOf('oil-pourer') !== -1;
    });
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string') {
      return tags.split(',').map(function (tag) { return tag.trim(); }).filter(Boolean);
    }
    return [];
  }

  function normalizeFilterValue(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function productMatchesCollectionOrTag(product, value) {
    var normalizedValue = normalizeFilterValue(value);
    var collectionHandles = product.collectionHandles || [product.collectionHandle];
    var collectionTitles = product.collectionTitles || [product.collectionTitle];
    var tags = product.tags || [];

    return collectionHandles.concat(collectionTitles).concat(tags).some(function (item) {
      return normalizeFilterValue(item) === normalizedValue;
    });
  }

  function isRecipientFilter(value) {
    var normalized = normalizeFilterValue(value);
    return ['baby', 'corporate', 'client', 'clients', 'him', 'her', 'kids', 'children', 'mum', 'mother', 'dad', 'father', 'recipient'].some(function (keyword) {
      return normalized.indexOf(keyword) !== -1;
    });
  }

  function uniqueValues(values) {
    var seen = {};
    return values.filter(function (value) {
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    }).sort();
  }

  function renderProducts(container) {
    var grid = container.querySelector('.gbb-grid');
    var emptyEl = container.querySelector('.gbb-grid__empty');
    if (!grid) return;

    var products = getFilteredProducts();

    if (products.length === 0 && !state.isLoading) {
      grid.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    var symbol = state.config.currencySymbol || '$';

    var html = products.map(function (p) {
      var selectedItem = getSelectedItem(p.id);
      var isSelected = Boolean(selectedItem);
      var isAddDisabled = !p.available;

      var priceHtml = '';
      if (p.compareAtPrice && parseFloat(p.compareAtPrice) > parseFloat(p.price)) {
        priceHtml = '<span class="gbb-card__price gbb-card__price--sale">' + formatPriceFromDollars(p.price, symbol) + '</span>' +
          '<span class="gbb-card__compare-price">' + formatPriceFromDollars(p.compareAtPrice, symbol) + '</span>';
      } else {
        priceHtml = '<span class="gbb-card__price">' + formatPriceFromDollars(p.price, symbol) + '</span>';
      }

      var btnText = !p.available ? 'Sold out' : 'Add to box';

      return '<div class="gbb-card' + (isSelected ? ' gbb-card--selected' : '') + '" data-product-id="' + p.id + '" role="button" tabindex="0" aria-label="View details for ' + escapeHtml(p.title) + '">' +
        '<div class="gbb-card__image-wrap">' +
        (p.image ? '<img class="gbb-card__image" src="' + p.image + '" alt="' + escapeHtml(p.title) + '" width="300" height="300" loading="lazy">' : '<div class="gbb-card__placeholder"></div>') +
        (isSelected ? '<div class="gbb-card__check">x' + selectedItem.qty + '</div>' : '') +
        '</div>' +
        '<div class="gbb-card__info">' +
        '<h3 class="gbb-card__title">' + escapeHtml(p.title) + '</h3>' +
        '<div class="gbb-card__prices">' + priceHtml + '</div>' +
        '</div>' +
        '<button class="gbb-card__add' + (isAddDisabled ? ' gbb-card__add--disabled' : '') + '" ' +
        'data-product-id="' + p.id + '" ' +
        (isAddDisabled ? 'disabled' : '') + '>' +
        btnText +
        '</button>' +
        '</div>';
    }).join('');

    grid.innerHTML = html;

    grid.querySelectorAll('.gbb-card__add').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        var productId = parseInt(btn.dataset.productId, 10);
        var product = state.allProducts.find(function (p) { return p.id === productId; });
        if (product) addItem(product, container);
        renderProducts(container);
        renderSelectedSummary(container);
      });
    });

    grid.querySelectorAll('.gbb-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var productId = parseInt(card.dataset.productId, 10);
        openProductModal(container, productId);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        var productId = parseInt(card.dataset.productId, 10);
        openProductModal(container, productId);
      });
    });
  }

  function renderSelectedSummary(container) {
    var summaryList = container.querySelector('.gbb-selected-summary');
    var countEl = container.querySelector('.gbb-step-1__count');
    if (!summaryList) return;

    var symbol = state.config.currencySymbol || '$';

    if (state.selectedItems.length === 0) {
      summaryList.innerHTML = '<p class="gbb-selected-summary__empty">No products selected yet. Browse above and add items to your gift box.</p>';
    } else {
      var html = '';
      state.selectedItems.forEach(function (item) {
        var itemTotal = (parseFloat(item.price) || 0) * item.qty;
        html += '<div class="gbb-selected-summary__item" data-summary-id="' + item.id + '">' +
          '<div class="gbb-selected-summary__image-wrap">' +
          (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" class="gbb-selected-summary__image" loading="lazy">' : '') +
          '</div>' +
          '<div class="gbb-selected-summary__details">' +
          '<span class="gbb-selected-summary__title">' + escapeHtml(item.title) + '</span>' +
          '<span class="gbb-selected-summary__price">x' + item.qty + ' · ' + formatPriceFromDollars(itemTotal, symbol) + '</span>' +
          '</div>' +
          '<button class="gbb-selected-summary__remove" data-remove-id="' + item.id + '" aria-label="Remove one">&minus;</button>' +
          '</div>';
      });
      summaryList.innerHTML = html;

      summaryList.querySelectorAll('.gbb-selected-summary__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var productId = parseInt(btn.dataset.removeId, 10);
          removeItem(productId);
          renderProducts(container);
          renderSelectedSummary(container);
        });
      });
    }

    if (countEl) countEl.textContent = '';
  }

  function getSelectedBox() {
    if (!state.selectedBoxColor) return null;
    var bp = state.config.boxProduct;
    if (!bp || !bp.variants || bp.variants.length === 0) {
      return {
        variantId: null,
        title: 'Asend Gift Box',
        image: '',
        price: state.config.boxBasePrice || '20'
      };
    }

    var colorLower = state.selectedBoxColor.toLowerCase();
    var variant = null;

    variant = bp.variants.find(function (v) {
      if (!v.options) return false;
      return v.options.some(function (opt) {
        return opt.toLowerCase().indexOf(colorLower) !== -1;
      });
    });

    if (!variant) {
      variant = bp.variants.find(function (v) {
        return v.title && v.title.toLowerCase().indexOf(colorLower) !== -1;
      });
    }

    if (!variant && bp.variants.length === 1) {
      variant = bp.variants[0];
      console.log('Gift Box Builder: Only one variant available, using it as fallback:', variant.title);
    }

    if (!variant) {
      console.warn('Gift Box Builder: No variant found matching "' + state.selectedBoxColor + '". Available:', bp.variants.map(function (v) { return v.title + ' opts:' + JSON.stringify(v.options); }));
      return {
        variantId: null,
        title: bp.title || 'Asend Gift Box',
        image: bp.image || '',
        price: state.config.boxBasePrice || '20'
      };
    }

    console.log('Gift Box Builder: Matched variant', variant.id, variant.title, 'for color', state.selectedBoxColor);

    return {
      variantId: variant.id,
      title: bp.title,
      image: variant.image || bp.image || '',
      price: variant.price
    };
  }

  function renderPreview(container) {
    var itemsContainer = container.querySelector('.gbb-preview__items');
    var countEl = container.querySelector('.gbb-preview__count');
    var totalEl = container.querySelector('.gbb-preview__total-price');

    if (!itemsContainer) return;

    var symbol = state.config.currencySymbol || '$';
    var box = getSelectedBox();
    var boxPrice = box ? (parseFloat(box.price) || 0) : 0;
    var total = boxPrice;
    var boxImage = box ? (box.image || '') : '';
    var colorLabel = state.selectedBoxColor ? ' (' + state.selectedBoxColor.charAt(0).toUpperCase() + state.selectedBoxColor.slice(1) + ')' : '';
    var boxTitle = box ? ((box.title || 'Gift Box') + colorLabel) : 'Gift Box';

    var html = '';

    if (box) {
      html += '<div class="gbb-preview__item gbb-preview__item--box">' +
        '<div class="gbb-preview__image-wrap">' +
        (boxImage ? '<img class="gbb-preview__image" src="' + boxImage + '" alt="' + escapeHtml(boxTitle) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="gbb-preview__details">' +
        '<span class="gbb-preview__title">' + escapeHtml(boxTitle) + '</span>' +
        '<span class="gbb-preview__price">' + formatPriceFromDollars(box.price || 0, symbol) + '</span>' +
        '</div>' +
        '<span class="gbb-preview__included">Included</span>' +
        '</div>';
    }

    state.selectedItems.forEach(function (item) {
      var itemTotal = (parseFloat(item.price) || 0) * item.qty;
      total += itemTotal;
      html += '<div class="gbb-preview__item" data-preview-id="' + item.id + '">' +
        '<div class="gbb-preview__image-wrap">' +
        (item.image ? '<img class="gbb-preview__image" src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="gbb-preview__details">' +
        '<span class="gbb-preview__title">' + escapeHtml(item.title) + '</span>' +
        '<span class="gbb-preview__price">x' + item.qty + ' · ' + formatPriceFromDollars(itemTotal, symbol) + '</span>' +
        '</div>' +
        '<button class="gbb-preview__remove" data-remove-id="' + item.id + '" aria-label="Remove one ' + escapeHtml(item.title) + '">&minus;</button>' +
        '</div>';
    });

    itemsContainer.innerHTML = html;

    if (countEl) countEl.textContent = '';

    if (totalEl) {
      totalEl.textContent = formatPriceFromDollars(total.toFixed(2), symbol);
    }

    itemsContainer.querySelectorAll('.gbb-preview__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var productId = parseInt(btn.dataset.removeId, 10);
        removeItem(productId);
        renderProducts(container);
        renderSelectedSummary(container);
        renderPreview(container);
      });
    });
  }

  function getSelectedItem(id) {
    return state.selectedItems.find(function (item) { return item.id === id; });
  }

  function getSelectedItemsCount() {
    return state.selectedItems.reduce(function (total, item) {
      return total + (item.qty || 1);
    }, 0);
  }

  function addItem(product, container) {
    if (getSelectedItemsCount() >= state.maxItems) {
      showLimitMessage(container);
      return false;
    }
    var existing = getSelectedItem(product.id);
    if (existing) {
      existing.qty += 1;
      hideLimitMessage(container);
      return true;
    }

    state.selectedItems.push({
      id: product.id,
      title: product.title,
      handle: product.handle,
      image: product.image,
      price: product.price,
      variantId: product.variantId,
      qty: 1
    });

    hideLimitMessage(container);
    return true;
  }

  function showLimitMessage(container) {
    if (!container) return;
    container.querySelectorAll('[data-gbb-limit-message]').forEach(function (message) {
      message.textContent = 'You can only add up to ' + state.maxItems + ' items.';
      message.style.display = 'block';
    });
  }

  function hideLimitMessage(container) {
    if (!container) return;
    container.querySelectorAll('[data-gbb-limit-message]').forEach(function (message) {
      message.style.display = 'none';
    });
  }

  function removeItem(productId) {
    var idx = state.selectedItems.findIndex(function (item) { return item.id === productId; });
    if (idx === -1) return;
    state.selectedItems[idx].qty -= 1;
    if (state.selectedItems[idx].qty <= 0) state.selectedItems.splice(idx, 1);
  }

  function openProductModal(container, productId) {
    var product = state.allProducts.find(function (p) { return p.id === productId; });
    var modal = container.querySelector('[data-gbb-product-modal]');
    if (!product || !modal) return;

    var image = modal.querySelector('.gbb-product-modal__image');
    var vendor = modal.querySelector('.gbb-product-modal__vendor');
    var title = modal.querySelector('.gbb-product-modal__title');
    var price = modal.querySelector('.gbb-product-modal__price');
    var description = modal.querySelector('.gbb-product-modal__description');
    var addButton = modal.querySelector('.gbb-product-modal__add');
    var symbol = state.config.currencySymbol || '$';

    modal.dataset.productId = String(product.id);

    if (image) {
      image.src = product.image || '';
      image.alt = product.title || '';
      image.style.display = product.image ? 'block' : 'none';
    }
    if (vendor) {
      vendor.textContent = product.vendor || '';
      vendor.style.display = product.vendor ? 'block' : 'none';
    }
    if (title) title.textContent = product.title || '';
    if (price) price.textContent = formatPriceFromDollars(product.price, symbol) + ' ' + (state.config.currencyCode || '');
    if (description) description.innerHTML = product.description || '<p>No description available.</p>';
    updateModalAddButton(addButton, product);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var closeBtn = modal.querySelector('.gbb-product-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeProductModal(container) {
    var modal = container.querySelector('[data-gbb-product-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateModalAddButton(button, product) {
    if (!button || !product) return;
    button.disabled = !product.available;
    button.textContent = !product.available ? 'Sold out' : 'Add to box';
  }

  function goToStep(step, container) {
    state.currentStep = step;

    container.querySelectorAll('.gbb-step').forEach(function (el) {
      el.classList.toggle('gbb-step--active', parseInt(el.dataset.step, 10) === step);
    });

    container.querySelectorAll('.gbb-progress__step').forEach(function (el) {
      var stepNum = parseInt(el.dataset.step, 10);
      el.classList.toggle('gbb-progress__step--active', stepNum === step);
      el.classList.toggle('gbb-progress__step--completed', stepNum < step);
    });

    container.querySelectorAll('.gbb-progress__line').forEach(function (el) {
      var afterStep = parseInt(el.dataset.afterStep, 10);
      el.classList.toggle('gbb-progress__line--active', afterStep < step);
    });

    if (step === 3) {
      renderPreview(container);
      var submitBtn = container.querySelector('.gbb-preview__submit');
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  function validateForm(container) {
    var errors = [];
    var boxColorErr = container.querySelector('.gbb-box-color-error');
    var boxColorGroup = container.querySelector('[data-gbb-box-color]');
    var occasion = container.querySelector('.gbb-preview__occasion');
    var occasionErr = container.querySelector('.gbb-occasion-error');
    var email = container.querySelector('.gbb-preview__email');
    var emailErr = container.querySelector('.gbb-email-error');
    var toField = container.querySelector('.gbb-preview__to');
    var toErr = container.querySelector('.gbb-to-error');
    var fromField = container.querySelector('.gbb-preview__from');
    var fromErr = container.querySelector('.gbb-from-error');
    var message = container.querySelector('.gbb-preview__message');
    var messageErr = container.querySelector('.gbb-message-error');
    var ageCheckbox = container.querySelector('.gbb-preview__age-checkbox');
    var ageErr = container.querySelector('.gbb-age-error');

    if (state.selectedItems.length === 0) {
      errors.push('Please select at least one product for your gift box.');
    }

    if (!state.selectedBoxColor) {
      errors.push('box_color');
      if (boxColorErr) boxColorErr.style.display = 'block';
      if (boxColorGroup) boxColorGroup.closest('.gbb-form-group').classList.add('gbb-form-group--error');
    } else {
      if (boxColorErr) boxColorErr.style.display = 'none';
      if (boxColorGroup) boxColorGroup.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
    }

    if (occasion && !occasion.value) {
      errors.push('occasion');
      if (occasionErr) occasionErr.style.display = 'block';
      var occasionGroup = occasion.closest('.gbb-form-group');
      if (occasionGroup) occasionGroup.classList.add('gbb-form-group--error');
    } else {
      if (occasionErr) occasionErr.style.display = 'none';
      if (occasion) {
        var occasionGroup2 = occasion.closest('.gbb-form-group');
        if (occasionGroup2) occasionGroup2.classList.remove('gbb-form-group--error');
      }
    }

    if (email) {
      var emailVal = email.value.trim();
      var emailValid = emailVal && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);
      if (!emailValid) {
        errors.push('email');
        if (emailErr) emailErr.style.display = 'block';
        email.closest('.gbb-form-group').classList.add('gbb-form-group--error');
      } else {
        if (emailErr) emailErr.style.display = 'none';
        email.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
      }
    }

    if (toField && !toField.value.trim()) {
      errors.push('to');
      if (toErr) toErr.style.display = 'block';
      toField.closest('.gbb-form-group').classList.add('gbb-form-group--error');
    } else {
      if (toErr) toErr.style.display = 'none';
      if (toField) toField.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
    }

    if (fromField && !fromField.value.trim()) {
      errors.push('from');
      if (fromErr) fromErr.style.display = 'block';
      fromField.closest('.gbb-form-group').classList.add('gbb-form-group--error');
    } else {
      if (fromErr) fromErr.style.display = 'none';
      if (fromField) fromField.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
    }

    if (message && !message.value.trim()) {
      errors.push('message');
      if (messageErr) messageErr.style.display = 'block';
      message.closest('.gbb-form-group').classList.add('gbb-form-group--error');
    } else {
      if (messageErr) messageErr.style.display = 'none';
      if (message) message.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
    }

    if (ageCheckbox && !ageCheckbox.checked) {
      errors.push('age');
      if (ageErr) ageErr.style.display = 'block';
    } else if (ageErr) {
      ageErr.style.display = 'none';
    }

    return errors;
  }

  async function addToCart(container) {
    var errors = validateForm(container);
    if (errors.length > 0) {
      showErrors(container, errors);
      return;
    }

    clearErrors(container);

    var submitBtn = container.querySelector('.gbb-preview__submit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('gbb-preview__submit--loading');
      submitBtn.innerHTML = 'Adding<span class="gbb-loading-dots"><span>.</span><span>.</span><span>.</span></span>';
    }

    var occasion = container.querySelector('.gbb-preview__occasion');
    var email = container.querySelector('.gbb-preview__email');
    var toField = container.querySelector('.gbb-preview__to');
    var fromField = container.querySelector('.gbb-preview__from');
    var message = container.querySelector('.gbb-preview__message');

    try {
      var qeCartData = buildQeCartData({
        occasion: occasion,
        email: email,
        toField: toField,
        fromField: fromField,
        message: message
      });

      var appResponse = await fetch('/apps/qe/frontend/graphql_create_cart_order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cart_data: [qeCartData],
          domain: state.config.shopDomain || window.Shopify.shop,
          storeid: state.config.storeId || '',
          builder_id: state.config.builderId || '3698',
          add_product_weight: 'off'
        })
      });

      if (!appResponse.ok) {
        throw new Error('The gift box app could not create the custom-priced box.');
      }

      var appData = await appResponse.json();
      var generatedVariantId = appData && appData[0] && appData[0].variant_data && appData[0].variant_data.variant
        ? appData[0].variant_data.variant.id
        : null;

      if (!generatedVariantId) {
        throw new Error('The gift box app did not return a generated box variant.');
      }

      await new Promise(function (resolve) { setTimeout(resolve, 8000); });

      var addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: generatedVariantId,
            quantity: 1,
            properties: buildQeCartProperties(qeCartData)
          }]
        })
      });

      if (!addResponse.ok) {
        var errorData = await addResponse.json();
        throw new Error(errorData.description || 'Failed to add to cart');
      }

      window.location.href = '/cart';
    } catch (err) {
      showErrors(container, [err.message || 'Something went wrong. Please try again.']);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('gbb-preview__submit--loading');
        submitBtn.textContent = 'Add to cart';
      }
    }
  }

  function getSelectedItemsTotal() {
    return state.selectedItems.reduce(function (total, item) {
      return total + ((parseFloat(item.price) || 0) * (item.qty || 1));
    }, 0);
  }

  function buildQeProduct(item) {
    var price = parseFloat(item.price) || 0;
    return {
      product_id: item.id,
      product_variant_id: item.variantId,
      product_img: item.image || '',
      product_name: item.title,
      product_options: ['Default Title - ' + (state.config.currencySymbol || '$') + price.toFixed(2)],
      product_original_price: price,
      product_price: price,
      product_qty: item.qty || 1,
      product_handle: item.handle || '',
      product_vendor: '',
      product_variant_sku: '',
      product_weight: 0,
      variant: 0,
      variantTitle: 'Default Title',
      productType: 'product'
    };
  }

  function buildQeCartData(fields) {
    var boxColor = state.selectedBoxColor === 'black' ? 'Black' : 'White';
    var boxBasePrice = parseFloat(state.config.boxBasePrice) || 0;
    var productTotal = getSelectedItemsTotal();
    var total = boxBasePrice + productTotal;
    var boxName = 'Asend ' + boxColor + ' Box';
    var boxHandle = state.selectedBoxColor === 'black' ? 'black-box' : 'white-box';
    var boxImage = state.selectedBoxColor === 'black'
      ? 'https://cdn.shopify.com/s/files/1/0793/8051/2987/files/Asend-Black-stack-Magnetic-close-box-1.jpg?v=1781784400'
      : 'https://cdn.shopify.com/s/files/1/0793/8051/2987/files/White-Box-Set-1-2.jpg?v=1781784397';

    return {
      box_key: 'qeboxkey' + (state.config.builderId || '3698') + '_' + Date.now(),
      bucket_weight_price: '',
      invt_location_name: '',
      invt_location_id: '',
      box_products_boxpricetype: 'variable_price',
      temp_bucket_total: total,
      tab_1: [{
        id: state.selectedBoxColor === 'black' ? 5614 : 5613,
        domain: state.config.shopDomain || window.Shopify.shop,
        box_productid: null,
        box_producthandle: boxHandle,
        box_name: boxName,
        box_images: boxImage,
        box_description: '',
        box_price: String(boxBasePrice),
        box_products_min_limit: '1',
        box_products_limit: String(state.maxItems),
        box_redirect_on: '',
        box_price_type: 'variable_price',
        box_pro_vari_id: '',
        product_id: '',
        product_variant_id: state.selectedBoxColor === 'black' ? 5614 : 5613,
        product_img: boxImage,
        product_name: boxName,
        product_options: [],
        product_original_price: boxBasePrice,
        product_price: boxBasePrice,
        product_qty: 1,
        product_handle: boxHandle,
        product_weight: 0,
        variant: 0,
        type: 'variable_price',
        variantTitle: '',
        productType: 'box',
        stepNumber: 1,
        step_name: 'Select Your Colour'
      }],
      tab_2: state.selectedItems.map(buildQeProduct),
      tab_3: [],
      tab_4: [
        { name: 'occasion', value: fields.occasion && fields.occasion.value ? fields.occasion.value : '' },
        { name: 'email', value: fields.email && fields.email.value ? fields.email.value.trim() : '' },
        { name: 'to', value: fields.toField && fields.toField.value ? fields.toField.value.trim() : '' },
        { name: 'from', value: fields.fromField && fields.fromField.value ? fields.fromField.value.trim() : '' },
        { name: 'gift_message', value: fields.message && fields.message.value ? fields.message.value.trim() : '' }
      ],
      delivery_date: '',
      audio_message_url: '',
      video_message_url: ''
    };
  }

  function buildQeCartProperties(qeCartData) {
    var properties = { '_handle': 'qe_byob' };
    var box = qeCartData.tab_1 && qeCartData.tab_1[0];
    if (box) {
      properties.Box = box.product_name;
      properties._boxid = box.product_variant_id || '';
    }

    qeCartData.tab_2.forEach(function (product, index) {
      var option = product.product_options && product.product_options[0] ? product.product_options[0].split(' - ').shift() : 'Default Title';
      var name = product.product_name;
      if (option.toLowerCase().indexOf('default') === -1) name += ' - ' + option;
      properties[name] = 'x' + product.product_qty;
      properties['_variantId' + (index + 1) + '_qty'] = product.product_variant_id + '_' + product.product_qty;
    });

    qeCartData.tab_4.forEach(function (field) {
      if (!field.value) return;
      var label = field.name.charAt(0).toUpperCase() + field.name.slice(1).replaceAll('_', ' ');
      properties[label] = field.value;
    });

    return properties;
  }

  function showErrors(container, errors) {
    clearErrors(container);
    var step = state.currentStep;
    var errorContainer = container.querySelector('.gbb-step[data-step="' + step + '"] .gbb-errors');
    if (!errorContainer) {
      errorContainer = container.querySelector('.gbb-errors');
    }
    if (!errorContainer) return;

    errorContainer.innerHTML = errors.map(function (msg) {
      return '<p class="gbb-errors__item">' + escapeHtml(msg) + '</p>';
    }).join('');
    errorContainer.style.display = 'block';
    errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearErrors(container) {
    container.querySelectorAll('.gbb-errors').forEach(function (el) {
      el.innerHTML = '';
      el.style.display = 'none';
    });
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function attachEventListeners(container) {
    container.querySelectorAll('.gbb-box-color__input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        state.selectedBoxColor = radio.value;
        var errEl = container.querySelector('.gbb-box-color-error');
        if (errEl) errEl.style.display = 'none';
        var group = container.querySelector('[data-gbb-box-color]');
        if (group) group.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
      });
    });

    var searchInput = container.querySelector('.gbb-search__input');
    var searchButton = container.querySelector('.gbb-search__button');

    if (searchInput) {
      var debounceTimer;
      searchInput.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          state.searchQuery = searchInput.value.trim();
          renderProducts(container);
        }, 300);
      });
    }

    if (searchButton) {
      searchButton.addEventListener('click', function () {
        state.searchQuery = searchInput ? searchInput.value.trim() : '';
        renderProducts(container);
      });
    }

    container.querySelectorAll('[data-gbb-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeProductModal(container);
      });
    });

    var modalAddButton = container.querySelector('.gbb-product-modal__add');
    if (modalAddButton) {
      modalAddButton.addEventListener('click', function () {
        var modal = container.querySelector('[data-gbb-product-modal]');
        var productId = modal ? parseInt(modal.dataset.productId, 10) : null;
        var product = state.allProducts.find(function (p) { return p.id === productId; });
        if (!product || modalAddButton.disabled) return;

        if (!addItem(product, container)) return;
        renderProducts(container);
        renderSelectedSummary(container);
        modalAddButton.disabled = true;
        modalAddButton.textContent = 'Added';

        setTimeout(function () {
          closeProductModal(container);
          updateModalAddButton(modalAddButton, product);
        }, 450);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeProductModal(container);
    });

    container.querySelectorAll('[data-gbb-next-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.gbbNextStep, 10);

        if (step === 2 && state.selectedItems.length === 0) {
          var summary = container.querySelector('.gbb-selected-summary');
          if (summary) {
            summary.innerHTML = '<p class="gbb-selected-summary__empty" style="color:#c00;">Please select at least one product for your gift box.</p>';
            summary.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
          return;
        }

        if (step === 3) {
          var errors = validateForm(container);
          if (errors.length > 0) {
            showErrors(container, errors);
            return;
          }
          clearErrors(container);
        }

        goToStep(step, container);
        container.scrollIntoView({ behavior: 'smooth' });
      });
    });

    container.querySelectorAll('[data-gbb-prev-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.gbbPrevStep, 10);
        goToStep(step, container);
        container.scrollIntoView({ behavior: 'smooth' });
      });
    });

    container.querySelectorAll('[data-gbb-goto-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.gbbGotoStep, 10);
        if (step > state.currentStep) return;
        goToStep(step, container);
        container.scrollIntoView({ behavior: 'smooth' });
      });
    });

    var submitBtn = container.querySelector('.gbb-preview__submit');
    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(container);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
